import React, { useEffect, useState } from 'react';

import { Form } from 'react-bootstrap';
import { BsArrowLeftSquareFill, BsArrowRightSquareFill } from "react-icons/bs";

/* import context function */
import { usePagination } from '../context/pageContext';

const Pagination = ({ totalCount = 0, style = {}, isReadOnly = false }) => {
	const { condition, setPagination } = usePagination();
	const [current, setCurrent] = useState(1);
	const [originalPage, setOriginal] = useState(1);
	const totalPages = Math.ceil(totalCount / condition.top);

    const handelPrevious = () => {
		if(current > 1)
			pagesHandler(current - 1);
	}

	const handelNext = () => {
		if (totalPages > current) {
			pagesHandler(current + 1);
		}
	}

	const handleEnter = event => {
		const currentPage = Number(event.target.value);
		
		if (event.code === 'Enter') {
			if (currentPage >= 1 && currentPage <= totalPages)
				pagesHandler(currentPage);
			else
				setCurrent(originalPage);
		}
	}

	const handleChange = event => {
		const currentText = event.target.value;
		
		setCurrent(currentText);
	}

	const pagesHandler = current => {
        const skip = (Number(current) * Number(condition.top)) - Number(condition.top);
		setPagination({ skip, top: condition.top });
    };

	const handleQuantity = ({ target: { value } }) => {
		setPagination({ skip: 0, top: Number(value) });
	};

	useEffect(() => {
		const { skip, top } = condition;
		const currentPage = (skip / top) + 1;
		
		setOriginal(currentPage);
		setCurrent(currentPage);
	}, [ condition ]);

    return (
        <div className="pagination-container">
            <BsArrowLeftSquareFill className="pre-button" onClick={ handelPrevious } />
            <div className="pagination-content" style={style}>
                <Form.Control className='current-page' type="test" size='sm' value={ current } onKeyDown={ handleEnter } onChange={ handleChange } readOnly={isReadOnly} />
                <span> / </span>
                <span className="total-pages">{ totalPages }</span>
            </div>
            <BsArrowRightSquareFill className="next-button" onClick={ handelNext } />
			<Form.Select className="quantity-select" onChange={ handleQuantity }>
				<option value="10">10筆</option>
				<option value="50">50筆</option>
				<option value="100">100筆</option>
			</Form.Select>
        </div>
    )
};

export default React.memo(Pagination);